export class FeedbackInfo {
    public mailFrom: string;
    public mailSubject: string;
    public mailSystemOrComponent: string;
    public mailBody: string;
}
